import merge from 'lodash/merge'
import { parseResponsiveProperty } from '@converdy/styles'
import baseBackgroundStyles from '@converdy/c-components/BaseBackground/BaseBackground.styles'


export function createPopupStyleSheet(jssInstance, jssObject, id) {
  
  const generateId = ({ key }, sheet) => {
    return id
  }
  return jssInstance.createStyleSheet(jssObject, { generateId, index: 2, meta: 'popup-styles'})

}

const contentAlignmentMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
}

const positionMap = {
  leftTop: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  leftCenter: {
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  leftBottom: {
    justifyContent: 'flex-start',
    alignItems: 'flex-end'
  },
  centerTop: {
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  centerCenter: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  centerBottom: {
    justifyContent: 'center',
    alignItems: 'flex-bottom'
  },
  rightTop: {
    justifyContent: 'flex-end',
    alignItems: 'flex-start'
  },
  rightCenter: {
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  rightBottom: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
}

export function popupJss(settings) {
  
  if(! settings) return {}
  const { maxWidth, height, customHeight, contentAlignment, position, showIcon, iconColor, showBackdrop, backdrop, background, corners} = settings
  
  const jss = {
    root: {}
  }

  merge(jss.root, {
    '& .popup-content': parseResponsiveProperty(w => {
      return w && w.value && w.unit ? {
        maxWidth: w.value + w.unit,
      } : {} 
    }, maxWidth)
  })


  if(height === '100vh') {
    merge(jss.root, {
      '& .popup-content': {
        height: '100vh'
      }
    })
  }
  

  if(height === 'custom') {

    merge(jss.root, {
      '& .popup-content': {
      ...parseResponsiveProperty(w => {
        return w && w.value ? {
          height: w.value + w.unit,
        } : {} 
      }, customHeight)
      }
    })
  }

  merge(jss.root, {
    '& .popup-content': {
    justifyContent: contentAlignmentMap[contentAlignment],
    }
  })

  merge(jss.root, {
    '&': {
    ...positionMap[position]
  }})

  if(iconColor) {
    merge(jss.root, {
      '& .popup-close-icon': {
        '--color': iconColor
      }
    })
  }

  if( showBackdrop ) {
    merge(jss.root, {
      '& .popup-backdrop':baseBackgroundStyles(backdrop)
    })
  }

  merge(jss.root, {
    '& .popup-content': baseBackgroundStyles(background)
  })
 
  merge(jss.root, {
    '& .popup-content': {
      borderRadius: corners.value + corners.unit
    }
  })

  return jss

}